import { Reducer } from 'redux';

import { TagType } from '@dev/ee-api/ee-api-models';
import { TemplateTagListState } from './types';

export const tagsDefaultState: TemplateTagListState = {
    type: TagType.Template,
    loadingTemplatesTags: false,
    templatesTagsList: [],
    name: null,
    DeletingTemplatesTag: false,
};

const reducer: Reducer = (state: TemplateTagListState = tagsDefaultState, action): TemplateTagListState => {
    switch (action.type) {
        case '@@templateTagList/LOADING_START':
        case '@@templateTagList/LOADING_SUCCESS':
        case '@@templateTagList/LOADING_ERROR':
        case '@@templateTagList/DELETE_START':
        case '@@templateTagList/DELETE_SUCCESS':
        case '@@templateTagList/DELETE_ERROR':
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export { reducer as templateTagList };

export default reducer;
